var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_831_5488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4673 9.20598L11.9016 9.20557C11.5234 9.20557 11.2168 9.51212 11.2168 9.89036V12.6267C11.2168 13.0049 11.5234 13.3115 11.9016 13.3115H16.7253C16.1971 14.6823 15.2112 15.8303 13.9534 16.5597L16.0103 20.1202C19.3096 18.2121 21.2603 14.864 21.2603 11.1161C21.2603 10.5824 21.2209 10.2009 21.1422 9.77138C21.0824 9.44502 20.7991 9.20598 20.4673 9.20598Z",
    fill: "#167EE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7605 17.423C8.39987 17.423 6.33908 16.1332 5.23228 14.2246L1.67188 16.2768C3.48374 19.417 6.87795 21.5317 10.7605 21.5317C12.6651 21.5317 14.4623 21.0189 16.0105 20.1252V20.1203L13.9537 16.5597C13.0129 17.1054 11.9241 17.423 10.7605 17.423Z",
    fill: "#12B347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0098 20.125V20.1201L13.953 16.5596C13.0121 17.1052 11.9235 17.4228 10.7598 17.4228V21.5315C12.6644 21.5315 14.4617 21.0187 16.0098 20.125Z",
    fill: "#0F993E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.36847 11.0317C4.36847 9.86817 4.68601 8.77957 5.23156 7.8388L1.67115 5.78662C0.772543 7.32992 0.259766 9.12222 0.259766 11.0317C0.259766 12.9413 0.772543 14.7336 1.67115 16.2769L5.23156 14.2247C4.68601 13.2839 4.36847 12.1953 4.36847 11.0317Z",
    fill: "#FFD500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7605 4.64044C12.2998 4.64044 13.7138 5.18742 14.8182 6.09727C15.0907 6.32171 15.4867 6.30551 15.7363 6.05593L17.6751 4.11712C17.9583 3.83395 17.9381 3.37043 17.6356 3.10801C15.7852 1.5027 13.3776 0.531738 10.7605 0.531738C6.87795 0.531738 3.48374 2.64638 1.67188 5.78662L5.23228 7.8388C6.33908 5.93022 8.39987 4.64044 10.7605 4.64044Z",
    fill: "#FF4B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8175 6.09727C15.09 6.32171 15.486 6.30551 15.7356 6.05593L17.6744 4.11712C17.9575 3.83395 17.9373 3.37043 17.6349 3.10801C15.7845 1.50266 13.3768 0.531738 10.7598 0.531738V4.64044C12.2991 4.64044 13.7131 5.18742 14.8175 6.09727Z",
    fill: "#D93F21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_831_5488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0.259766 0.531738)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.bb0576b5187032d0b74ccb5d34d564ac.svg";
export { ForwardRef as ReactComponent };